import { useCallback } from 'react';
import { useConversation } from '../contexts/ConversationContext';

export interface DrillDownPayload {
  field: string;
  value: string;
  label?: string;
}

/**
 * Hook to handle drill-down interactions on charts
 * When a chart element is clicked, this generates a follow-up query
 */
export function useDrillDown() {
  const { submitQuery, activeFilters } = useConversation();

  const handleDrillDown = useCallback(
    (payload: DrillDownPayload) => {
      const { field, value, label } = payload;

      // Build a natural language query for drilling down
      const fieldLabel = label || field.replace(/_/g, ' ');
      const existingFilters = activeFilters
        .map((f) => f.label.toLowerCase())
        .join(', ');

      let query: string;
      if (existingFilters) {
        query = `Show me items where ${fieldLabel} is "${value}" (keeping existing filters: ${existingFilters})`;
      } else {
        query = `Show me items where ${fieldLabel} is "${value}"`;
      }

      submitQuery(query);
    },
    [submitQuery, activeFilters]
  );

  return { handleDrillDown };
}

export default useDrillDown;
